import type { DemoKey } from '../types';

export const de: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'Mathematik · Statistik',
  'app.title': 'Statistik',
  'panel.experiment': 'Szene',
  'panel.params': 'Parameter',

  'exp.survey-explorer.title': 'Umfrage-Explorer',
  'exp.survey-explorer.desc': 'Wähle eine Spalte; die Demo wählt die passende Zusammenfassung.',
  'exp.distribution-sculptor.title': 'Verteilungs-Bildhauer',
  'exp.distribution-sculptor.desc':
    'Verschiebe Punkte und beobachte, wie die Kennzahlen reagieren.',
  'exp.two-variable-lab.title': 'Zwei-Variablen-Labor',
  'exp.two-variable-lab.desc': 'Streudiagramm, Anpassung, Frage nach der Ursache.',
  'exp.sampling-lab.title': 'Stichproben-Labor',
  'exp.sampling-lab.desc': 'Wie Verfahren und Größe den Stichprobenmittelwert verschieben.',
  'exp.probability-diagrams.title': 'Wahrscheinlichkeitsdiagramme',
  'exp.probability-diagrams.desc': 'Venn- und Baum-Ansichten für zusammengesetzte Ereignisse.',

  'type.qualitative-nominal.label': 'Qualitativ · nominal',
  'type.qualitative-nominal.def': 'Kategorien ohne inhärente Reihenfolge.',
  'type.qualitative-ordinal.label': 'Qualitativ · ordinal',
  'type.qualitative-ordinal.def': 'Kategorien mit sinnvoller Reihenfolge.',
  'type.qualitative-multi.label': 'Qualitativ · mehrwertig',
  'type.qualitative-multi.def': 'Jede Beobachtung kann mehrere Marker haben.',
  'type.quantitative-discrete.label': 'Quantitativ · diskret',
  'type.quantitative-discrete.def': 'Zahlen in festen Schritten.',
  'type.quantitative-continuous.label': 'Quantitativ · stetig',
  'type.quantitative-continuous.def': 'Zahlen auf stetiger Skala gemessen.',

  'column.name.label': 'Schülername',
  'column.height_cm.label': 'Größe',
  'column.shoe_size_eu.label': 'Schuhgröße (EU)',
  'column.study_hours.label': 'Lernstunden / Woche',
  'column.test_score.label': 'Testergebnis',
  'column.sports_played.label': 'Ausgeübte Sportarten',
  'column.eye_color.label': 'Augenfarbe',
  'column.commute_min.label': 'Schulweg',
  'column.grade_year.label': 'Jahrgang',
  'column.homework_effort.label': 'Hausaufgabeneinsatz',
  'column.ice-cream-sales.label': 'Eisverkäufe',
  'column.drownings.label': 'Ertrinkungen',
  'column.month.label': 'Monat',
  'column.storks.label': 'Störche',
  'column.births.label': 'Geburten',
  'column.country_area_km2.label': 'Landesfläche',
  'column.sleep_hours.label': 'Schlafstunden',
  'column.reaction_ms.label': 'Reaktionszeit',

  'dataset.master-survey.label': 'Klassenumfrage',
  'dataset.master-survey.desc': '30 simulierte Schüler.',
  'dataset.spurious-ice-cream-vs-drownings.label': 'Eisverkäufe vs Ertrinkungen',
  'dataset.spurious-ice-cream-vs-drownings.desc':
    'Beide steigen und fallen mit der Saison. Ertrinkungen verursachen keine Eisverkäufe.',
  'dataset.spurious-storks-vs-births.label': 'Störche vs Geburten',
  'dataset.spurious-storks-vs-births.desc':
    'Größere Länder haben mehr Störche und mehr Geburten. Die Vögel sind nicht die Ursache.',
  'dataset.real-sleep-vs-reaction-time.label': 'Schlaf vs Reaktionszeit',
  'dataset.real-sleep-vs-reaction-time.desc':
    'Mehr Schlaf, schnellere Reaktionen. Eine echte negative Korrelation — und ein plausibler Mechanismus.',

  'tag.football.label': 'Fußball',
  'tag.basketball.label': 'Basketball',
  'tag.volleyball.label': 'Volleyball',
  'tag.swimming.label': 'Schwimmen',
  'tag.none.label': 'Keine',

  'population.gaussian.label': 'Glockenkurve',
  'population.right-skewed.label': 'Rechtsschief',
  'population.bimodal.label': 'Bimodal (mit Schichten)',
  'population.uniform.label': 'Gleichverteilt',

  'venn.dice-even-or-prime.label': 'Würfel: gerade oder prim',
  'venn.class-sports-2set.label': 'Sportarten (2 Mengen)',
  'venn.class-sports-3set.label': 'Sportarten (3 Mengen)',
  'venn.custom.label': 'Benutzerdefiniert',

  'tree.draw-without-replacement.label': 'Ziehen ohne Zurücklegen',
  'tree.custom.label': 'Benutzerdefiniert',
  'tree.coin.heads': 'K',
  'tree.coin.tails': 'Z',
  'tree.draw.start': 'Beutel: 2 rote, 3 blaue',
  'tree.draw.red': 'Rot',
  'tree.draw.blue': 'Blau',
  'tree.custom.start': 'Start',
  'tree.custom.A': 'A',
  'tree.custom.B': 'B',

  'card.histogram': 'Histogramm',
  'card.cumulative': 'Kumulative Häufigkeit',
  'card.box': 'Box-Plot',
  'card.summary': 'Fünf-Werte-Zusammenfassung',
  'card.bar': 'Balkendiagramm',
  'card.mode': 'Modus',
  'card.tag-frequency': 'Markierungs-Häufigkeit',
  'card.mode-tag': 'Häufigste Marke',
  'card.empty-no-order': 'Nicht anwendbar',
  'card.empty-multi': 'Nicht anwendbar',
  'card.numberline': 'Zahlenstrahl',
  'card.scatter': 'Streudiagramm',
  'card.description': 'Was passiert',
  'card.population': 'Population',
  'card.sampling-distribution': 'Stichprobenmittel',
  'card.venn': 'Venn',
  'card.tree': 'Baum',
  'card.probabilities': 'Wahrscheinlichkeiten',

  'param.dataset.label': 'Datensatz',
  'param.column.label': 'Spalte',
  'param.bins.label': 'Klassen',
  'param.shape.label': 'Startform',
  'param.show-mean.label': 'Mittelwert zeigen',
  'param.show-median.label': 'Median zeigen',
  'param.x-col.label': 'X-Spalte',
  'param.y-col.label': 'Y-Spalte',
  'param.show-regression.label': 'Regressionsgerade',
  'param.show-residuals.label': 'Residuen',
  'param.show-confounder.label': 'Confounder zeigen',
  'param.population.label': 'Population',
  'param.technique.label': 'Verfahren',
  'param.sample-size.label': 'Stichprobengröße',
  'param.stratum.label': 'Schicht',
  'param.bias.label': 'Verzerrung',
  'param.mode.label': 'Modus',
  'param.preset.label': 'Voreinstellung',
  'param.universe.label': 'Universumsgröße',
  'param.show-prob.label': 'Wahrscheinlichkeiten zeigen',
  'param.treat-as-numeric.label': 'Als numerisch behandeln',

  'stat.count': 'Anzahl',
  'stat.mean': 'Mittelwert',
  'stat.median': 'Median',
  'stat.range': 'Spannweite',
  'stat.q1': 'Q1',
  'stat.q3': 'Q3',
  'stat.iqr': 'IQR',
  'stat.outliers': 'Ausreißer',
  'stat.r': 'Pearson r',
  'stat.r2': 'r²',
  'stat.slope': 'Steigung',
  'stat.intercept': 'Achsenabschnitt',
  'stat.n': 'n',
  'stat.population-mean': 'Wahrer Mittelwert',
  'stat.latest-sample-mean': 'Stichprobenmittel',
  'stat.sample-mean-spread': 'SD Stichprobenmittel',
  'stat.sample-count': 'Gezogene Stichproben',
  'outlier.upper': 'Obere Ausreißer',
  'outlier.lower': 'Untere Ausreißer',

  'region.A': 'A',
  'region.B': 'B',

  'btn.resample': 'Neu ziehen',
  'btn.run-100': '100 Stichproben ziehen',
  'btn.stop': 'Stopp',
  'btn.clear-history': 'Verlauf löschen',

  'explainer.no-order': 'Ohne Ordnung → keine Kumulierte, kein Box-Plot.',
  'explainer.multi-no-iqr': 'Mehrwertig → Quartile / IQR nicht definiert.',
  'message.no-data': 'Keine Daten.',
  'message.needs-quartiles': '≥4 Punkte für Quartile nötig.',
  'message.x-zero-variance': 'X hat Varianz null — keine Gerade anpassbar.',
  'message.n-too-small': 'n zu klein.',
  'message.stratum-clamp': 'Schicht hatte weniger Zeilen als verlangt — alle verwendet.',
  'message.siblings-sum-to-one': 'Geschwister müssen zu 1 summieren.',
};
